
export class NodoArbolMenu{
  public id: string;
  public menuId: string;
  public name: string;
  public type: string;
  public parentId: string;
  public assistanceId: string;
  public answer: string;
  public order: number;
  public creationDate: number;
  public updateDate: number;
  public updateUser: string;
  public level: number;
  public childs: NodoArbolMenu[];
  public faqs: {id:string, consulta:string, respuesta:string, codigoTemaDestinatario:string}[];
  public path: string;
  public areaCode: string;
  public conDestinatario: boolean;
  public esFormulario: boolean;

  constructor(
    id:string,
    idMenu:string,
    nombre: string,
    tipoNodo: string,
    idPadre: string,
    idAsistencia: string,
    respuesta: string,
    path:string,
    codigoTemaDestinatario:string,
    orden: number = undefined,
    fechaCreacion: number = undefined,
    fechaActualizacion: number = undefined,
    usuarioActualizacion: string = undefined,
    nivel: number = undefined,
    faqs: {id:string, consulta:string, respuesta:string, codigoTemaDestinatario:string}[] = undefined,
    conDestinatario:boolean= false,
    esFormulario:boolean= false
  ) {
    this.id = id;
    this.menuId = idMenu;
    this.name = nombre;
    this.type = tipoNodo;
    this.parentId = idPadre;
    this.assistanceId = idAsistencia;
    this.answer = respuesta;
    this.path = path;
    this.areaCode = codigoTemaDestinatario;
    this.order = orden;
    this.creationDate = fechaCreacion;
    this.updateDate = fechaActualizacion;
    this.updateUser = usuarioActualizacion;
    this.level = nivel;
    this.faqs = faqs;
    this.conDestinatario = conDestinatario;
    this.esFormulario = esFormulario;
  }

  buildTree(jsonNodoMenu):NodoArbolMenu[] {
    if (jsonNodoMenu.childs.length == 0) {
      return [] ;
    }
    for (let child of jsonNodoMenu.childs) {
      let nodo = new NodoArbolMenu(
          child.id,
          child.idMenu,
          child.nombre,
          child.tipoNodo,
          child.idPadre || "ROOT",
          child.idAsistencia,
          child.respuesta,
          child.path,
          child.codigoTemaDestinatario,
          child.orden,
          child.fechaCreacion,
          child.fechaActualizacion,
          child.usuarioActualizacion,
          child.nivel,
          child.faqs,
          child.conDestinatario,
          child.esFormulario    
      );
      nodo.childs = nodo.buildTree(child)
      if (this.childs==undefined){
          this.childs = []
      }
      this.childs.push(nodo);
    }
    return this.childs;
  }


  search(nodeId:string){
    if (this.id === nodeId){
      return this;
    }
    if (this.childs && this.childs.length>0){
      for(let child of this.childs){
        let result = child.search(nodeId);
        if(result!== null){
           return result;
        };
      }
    }
    return null;
  }
  
}
